import { List, Record } from "immutable";

import { ClassEnrollments } from "./ClassEnrollments";
import ClassEnrollmentsMetaState from "./ClassEnrollmentsMetaState";

export type ClassEnrollmentsStateSliceType = {
  enrollments: ClassEnrollments;
  childEnrollments: ClassEnrollments;
  meta: ClassEnrollmentsMetaState;
};

export type OptionalClassEnrollmentsStateSliceType =
  Partial<ClassEnrollmentsStateSliceType>;

const defaultClassEnrollmentsStateSlice: ClassEnrollmentsStateSliceType = {
  enrollments: List(),
  childEnrollments: List(),
  meta: new ClassEnrollmentsMetaState()
};

export default class ClassEnrollmentsStateSlice extends Record(
  defaultClassEnrollmentsStateSlice
) {}
